import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import SubCard from "ui-component/cards/SubCard";
import {
  Button,
  TextField,
  Box,
  Typography,
  Grid,
  Card,
  // CardContent,
  Tooltip,
  Stack,

} from "@mui/material";
import * as XLSX from "xlsx";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useEffect } from "react";
import SnackBar from "../../General/SnackBar";
import BackdropLoader from "../../General/Loader";
// import { GetPurchaseOrder } from "API/PurchaseOrder/api";
import PurchaseOrderDialog from "./PurchaseOrderModal";
import PaymentOrderDialog from "./PaymentOrderDialog";
import { GetPaymentOrders } from "API/PaymentOrder/api";
// import Autocomplete from '@mui/material/Autocomplete';
import { GetAllDevice } from "API/PurchaseRequest/api";
import { GetUserRole } from "API/Misc/MakerChecker";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import RemarksDialog from "./RemarksDialog";

function formatDate(dateString) {
  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;
  return `${formattedDate}`;
}



//  const CalculateAmount = ( params ) => {
      
//   console.log("params",params);
  
      
//     const totalAmount =
//     params.total.quantity && Array.isArray(params.total.quantity)
//       ? params.total.quantity.reduce((sum, item) => {
//           if (item.price) {
//             return parseFloat((sum + item.price)*1.00);
//           }
//           return parseFloat(sum*1.00);
//         }, 0)
//       : 0;
    
//           console.log("totalAmount ",totalAmount);
//       return (
//         <Typography variant="body1">
//           <table>
//             <tbody>
//               <tr>
//                 {
//                   params.total.purchase_order_details&&params.total.purchase_order_details.tax_type==="interstate"?
//                   <td>₹{(((totalAmount+parseInt(params.total.updated_tax.igst) + Number.EPSILON) * 100) / 100).toFixed(2)}</td>
//                   :
//                   <td>₹{(((totalAmount+parseInt(params.total.updated_tax.cgst)+parseInt(params.total.updated_tax.sgst) + Number.EPSILON) * 100) / 100).toFixed(2)}</td>
  
//                 }
//               </tr>
//             </tbody>
//           </table>
//         </Typography>
//       );
//     };


    

// const GetBalanceAmount=(params)=>{
//   const totalAmount =
//   params.quantity && Array.isArray(params.quantity)
//     ? params.quantity.reduce((sum, item) => {
//         if (item.price) {
//           return parseFloat((sum + item.price)*1.00);
//         }
//         return parseFloat(sum*1.00);
//       }, 0)
//     : 0;

//     return params.purchase_order_details&&params.purchase_order_details.tax_type==="interstate"?
//     (((eval(params.purchase_order_details.sub_total+parseInt(params.purchase_order_details.tax.igst))-totalAmount+parseInt(params.updated_tax.igst) + Number.EPSILON) * 100) / 100).toFixed(2)
//     :
//     (((totalAmount+parseInt(params.updated_tax.cgst)+parseInt(params.updated_tax.sgst) + Number.EPSILON) * 100) / 100).toFixed(2)
// }
  // const CalculateBalanceAmount = ( params ) => {
      
  //     console.log("params",params);
      
      
          
  //       const totalAmount =
  //       params.total.quantity && Array.isArray(params.total.quantity)
  //         ? params.total.quantity.reduce((sum, item) => {
  //             if (item.price) {
  //               return parseFloat((sum + item.price)*1.00);
  //             }
  //             return parseFloat(sum*1.00);
  //           }, 0)
  //         : 0;
        
  //             console.log("totalAmount ",totalAmount);
  //         return (
  //           <Typography variant="body1">
  //             <table>
  //               <tbody>
  //                 <tr>
  //                   {
  //                     params.total.purchase_order_details&&params.total.purchase_order_details.tax_type==="interstate"?
  //                     <td>₹{(((eval(params.total.purchase_order_details.sub_total+parseInt(params.total.purchase_order_details.tax.igst))-(totalAmount+parseInt(params.total.updated_tax.igst) + Number.EPSILON)) * 100) / 100).toFixed(2)}</td>
  //                     :
  //                     <td>₹{(((eval(params.total.purchase_order_details.sub_total+parseInt(params.total.purchase_order_details.tax.igst)))-(totalAmount+parseInt(params.total.updated_tax.cgst)+parseInt(params.total.updated_tax.sgst) + Number.EPSILON) * 100) / 100).toFixed(2)}</td>
      
  //                   }
  //                 </tr>
  //               </tbody>
  //             </table>
  //           </Typography>
  //         );
  //       };

const columns = (handleViewPO, handlePaymentOrderOpen,handleRemarksOpen) => [
  { field: "payment_order_id", headerName: "Payment Order Number", flex: 2, minWidth: 200 },
  { field: "_id",
     headerName: "Purchase Order Number",
     flex: 2,
     minWidth: 200,
    renderCell:(params)=>(
      <table>
        {
          params.row.purchase_order_details ?
            
              <tr>{params.row.purchase_order_details.purchase_order_id}</tr>
            
            :
            <tr></tr>
        }
      </table>
    )
   },
  {
    field: "date",
    headerName: "Date",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <Typography>{params.row ? formatDate(params.row.created_at) : ''}</Typography>
    )
  },
  {
    field: "bank",
    headerName: "Bank Name",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <table>{
        params.row.purchase_request_details && params.row.purchase_request_details ?
          params.row.purchase_request_details.filter(item=>params.row.quantity.find(sub=>sub.device_id===item.device_details._id)).map((item, index) => (
            <tr key={index}>{item.device_details.bank_name}</tr>
          ))

          :
          <tr></tr>


      }
      </table>
    )
  },
  {
    field: "brand",
    headerName: "Brand Name",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <table>{
        params.row.purchase_request_details && params.row.purchase_request_details ?
          params.row.purchase_request_details.filter(item=>params.row.quantity.find(sub=>sub.device_id===item.device_details._id)).map((item, index) => (
            <tr key={index}>{item.device_details.brand_name}</tr>
          ))

          :
          <tr></tr>


      }
      </table>
    )
  },
  {
    field: "device",
    headerName: "Device Name",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <table>{
        params.row.purchase_request_details && params.row.purchase_request_details ?
          params.row.purchase_request_details.filter(item=>params.row.quantity.find(sub=>sub.device_id===item.device_details._id)).map((item, index) => (
            <tr key={index}>{item.device_details.name}</tr>
          ))

          :
          <tr></tr>


      }
      </table>
    )
  },
  {
    field: "modelnumber",
    headerName: "Model Number",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <table>{
        params.row.purchase_request_details && params.row.purchase_request_details ?
          params.row.purchase_request_details.filter(item=>params.row.quantity.find(sub=>sub.device_id===item.device_details._id)).map((item, index) => (
            <tr key={index}>{item.device_details.model}</tr>
          ))

          :
          <tr></tr>


      }
      </table>
    )
  },

  {
    field: "quantity",
    headerName: "Quantity",
    flex: 1,
    minWidth: 100,
    renderCell: (params) => (
      <table>{params.row.quantity && Array.isArray(params.row.quantity) ?
        params.row.quantity.map((item, index) => (
          item.quantity ?
            <tr key={index}>{item.quantity}</tr>
            :
            <tr key={index}></tr>
        ))
        :
        null
      }
      </table>
    )
  },

  {
    field: "vendor",
    headerName: "Vendor Name",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <Typography>{params.row.purchase_order_details && params.row.purchase_order_details.vendor_details ? params.row.purchase_order_details.vendor_details.vendor_name : ''}</Typography>
    )
  },
 
  {
    field: "total_amount",
    headerName: "Total amount",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
          <Typography>₹{params.row && params.row.total_price?.toLocaleString('en-IN')}</Typography>
    )


  },

  { field: "poadueamount", 
    headerName: "PO Due Amount", 
    flex: 1, 
    minWidth: 150,
    renderCell: (params) => (
      <Typography>₹{params.row.due_amount?.toLocaleString('en-IN')}</Typography>
    )
   },

    { field: "utr", 
    headerName: "Utr", 
    flex: 1, 
    minWidth: 150,
    renderCell: (params) => (
      <Typography>{params.row.utr?params.row.utr:"-"}</Typography>
    )
   },

    { field: "tds", 
    headerName: "Tds", 
    flex: 1, 
    minWidth: 150,
    renderCell: (params) => (
      <Typography>{params.row.tds?params.row.tds:"-"}</Typography>
    )
   },

    { field: "payment_amount", 
    headerName: "Payment Amount", 
    flex: 1, 
    minWidth: 150,
    renderCell: (params) => (
      <Typography>{params.row.amount_paid?params.row.amount_paid:"-"}</Typography>
    )
   },

  {
    field: "fh_approval_status", headerName: "Status", flex: 1, minWidth: 120,
    renderCell: (params) => (
      <Box
        sx={{
          color:
            params.row.approval_status === "approved"
              ? "green"
              : params.row.approval_status === "rejected"
                ? "orange"
                : "red",
        }}
      >
        {params.row.approval_status ? params.row.approval_status : "pending"}
      </Box>
    ),
  },
  {
    field: "payent_status", headerName: "Payment Status", flex: 1, minWidth: 200,
    renderCell: (params) => (
      <Box
        sx={{
          color:
            params.row.payment_status === "approved"
              ? "green"
              : params.row.payment_status === "rejected"
                ? "orange"
                : "red",
        }}
      >
        {params.row.payment_status ? params.row.payment_status : "pending"}
      </Box>
    ),
  },
  {
    field: "action",
    headerName: "Action",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Tooltip title="View Purchase Order Details">
          <Stack gap={1}>
            <Button
              disableFocusRipple
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => handlePaymentOrderOpen(params.row)}
            >
              View
            </Button>
            <Button
              disableFocusRipple
              variant="outlined"
              color="primary"
              size="small"
              sx={{ display: "none" }}
              onClick={() => handlePaymentOrderOpen(params.row)}
            >
              Create payment order
            </Button>
          </Stack>
        </Tooltip>
      </Box>
    ),
  },
  { field: "remarks", 
    headerName: "Remarks", 
    flex: 1, 
    minWidth: 150,
    renderCell: (params) => (
      <Button variant="outlined" size="small" onClick={()=>handleRemarksOpen(params.row)}>View</Button>
    )
   },
];

const PaymentOrderTable = () => {
  
  const currentDate = new Date();
  const formattedDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;
  const [actionFilter, setActionFilter] = useState("Pending");
  const [Data, setData] = useState(null)
  const [Page, setPage] = useState(1);
  const [IsLoading, setIsLoading] = useState(false)
  const [AlertMessage, setAlertMessage] = useState(null)
  const [AlertType, setAlertType] = useState("success")
  const [OpenAlert, setOpenAlert] = useState(false)
  const [UserRole, setUserRole] = useState(null)
  const [OpenRemarks, setOpenRemarks] = useState(false)
  const [RemarksData,setRemarksData] = useState(null)

  const [filters, setFilters] = useState({
    from_date: formattedDate,
    to_date: formattedDate,
    device: "",
  });


  const handleRemarksOpen=(data)=>{
    setRemarksData(data)
    setOpenRemarks(true)
  }

  const handleRemarksClose=()=>{
    setOpenRemarks(false)
  }


  // for po dialog

  const [Open, setOpen] = useState(false)
  const [SelectedRows, setSelectedRows] = useState(null)
  const [OpenPaymentOrder, setOpenPaymentOrder] = useState(false)
  const [Devices, setDevices] = useState(null)



  const handleAlertOpen = (message, type) => {
    setAlertType(type)
    setAlertMessage(message)
    setOpenAlert(true)
  }


  const handleAlertClose = () => {
    setOpenAlert(false)
  }


  useEffect(() => {
    
    console.log("Triggered");
     
    GetUserRole("payment_order", setIsLoading, setUserRole, handleAlertOpen)
  }, [])

  useEffect(() => {
    if (UserRole) {
      console.log("Triggered");
      
      GetPaymentOrders(setIsLoading, handleAlertOpen, setData, 1, actionFilter.toLowerCase(), UserRole,filters)
      GetAllDevice(setIsLoading, setDevices, handleAlertOpen)
    }


  }, [actionFilter, UserRole])


  const handleChangePage = (page) => {
    
    console.log("Triggered");
     
    GetPaymentOrders(setIsLoading, handleAlertOpen, setData, page + 1, actionFilter.toLowerCase(),UserRole,filters)
    setPage(page + 1)
  }


  // console.log("Data",Data);

  const filteredData = Data && Data.data && Array.isArray(Data.data) && Data.data.filter((row) => {
    return (

      (

        row

      )
    );
  });

  const handleViewPO = (row) => {
    setSelectedRows(row)
    setOpen(true)
  };

  const handlePaymentOrderOpen = (row) => {
    setSelectedRows(row)
    setOpenPaymentOrder(true)
  };

  const handlePaymentOrderClose = () => {
    setOpenPaymentOrder(false)
  };

  const handlePoClose = () => {
    setOpen(false)
  }

  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
  };


  const handleSearch=()=>{
    
    console.log("Triggered");
     
    GetPaymentOrders(setIsLoading, handleAlertOpen, setData, 1, actionFilter.toLowerCase(), UserRole, filters)
  }

  const resetFilters = () => {
    
    console.log("Triggered");
     
    setFilters({from_date:formattedDate,to_date:formattedDate,device:""});
    GetPaymentOrders(setIsLoading, handleAlertOpen, setData, 1, actionFilter.toLowerCase(), UserRole, {from_date:formattedDate,to_date:formattedDate,device:""})

  };



  const exportToExcel = () => {

    console.log("Filtered data",filteredData);
    
    const mappedData = filteredData.map(item => ({
          "Payment Order No": item.payment_order_id,
          "PO No": item.purchase_request_details
            .map(sub => sub.purchase_request_id)
            .join(", "),
          "Date": item.purchase_order_details.po_date,
          "Brand Name": item.purchase_request_details
            .map(sub => sub.device_details.brand_name)
            .join(", "),
          "Device Name": item.purchase_request_details
            .map(sub => sub.device_details.name)
            .join(", "),
          "Model No": item.purchase_request_details
            .map(sub => sub.device_details.model)
            .join(", "),
          "Description": item.purchase_request_details
            .map(sub => sub.device_details.description)
            .join(", "),
          "Vendor's Name": item.purchase_order_details.vendor_details.vendor_name,
          "Quantity": item.quantity
            .map(sub => sub.quantity)
            .join(", "),
          "Total Amount": item.total_price,
          "Due Amount": item.due_amount,
          "Status": item.approval_status,
        }));
      
        const worksheet = XLSX.utils.json_to_sheet(mappedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Purchase Orders");
        XLSX.writeFile(workbook, "PaymentOrders.xlsx");
  };

  return (
    <Box p={1} sx={{ minHeight: "100vh" }}>
      <RemarksDialog open={OpenRemarks} handleClose={handleRemarksClose} data={RemarksData}/>
      <PaymentOrderDialog filter={actionFilter} UserRole={UserRole} open={OpenPaymentOrder} handleClose={handlePaymentOrderClose} data={SelectedRows} type="write" />
      <PurchaseOrderDialog open={Open} handleClose={handlePoClose} data={SelectedRows} type="write" />
      <SnackBar open={OpenAlert} message={AlertMessage} type={AlertType} handleClose={handleAlertClose} />
      <BackdropLoader open={IsLoading} />
      
          {/* Enhanced Filter Section */}
          <Card variant="outlined" sx={{ padding: 2, marginBottom: 3 }}>
            {/* <Typography variant="h6" gutterBottom>
              Search Filters
            </Typography> */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={3}>
                 <Typography variant='h5' sx={{color:"#20415C",marginBottom:1}} fontWeight={600} >From Date</Typography>
                <TextField
                  variant="outlined"
                  size="small"
                  type="date"
                  value={filters.from_date}
                  inputProps={
                    {
                      max: formattedDate
                    }
                  }
                  InputLabelProps={
                    {
                      shrink: true,
                    }
                  }
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      border: '2px solid #A9A9A980 50%', // change border color
                      borderRadius: '8px',
                    },
                    '& fieldset': {
                        borderColor: '#A9A9A980', 
                        borderRadius:'8px'// default border color
                    },  
                  }}
                  onChange={(e) => handleFilterChange("from_date", e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                 <Typography variant='h5' sx={{color:"#20415C",marginBottom:1}} fontWeight={600} >To Date</Typography>
                <TextField
                  variant="outlined"
                  size="small"
                  type="date"
                  value={filters.to_date}
                  InputLabelProps={
                    {
                      shrink: true,
                    }
                  }
                  inputProps={
                    {
                      max: formattedDate,
                      min: filters.from_date

                    }
                  }
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      border: '2px solid #A9A9A980 50%', // change border color
                      borderRadius: '8px',
                    },
                    '& fieldset': {
                        borderColor: '#A9A9A980', 
                        borderRadius:'8px'// default border color
                    },  
                  }}
                  onChange={(e) => handleFilterChange("to_date", e.target.value)}
                  onKeyDown={(e) => e.preventDefault()}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3} sx={{visibility:'hidden'}}>
              <FormControl fullWidth size='small'>
                                <InputLabel id="demo-simple-select-label">Device</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={filters.device}
                                    label="Device"
                                    onChange={(e) => handleFilterChange("device", e.target.value)}
                                    >
                                    {
                                        Devices&&Devices.map((item,index)=>(
                                            <MenuItem value={item._id} key={index}>{item.bank_name}-{item.brand_name}-{item.name}</MenuItem>
                                        ))
                                    }
                                   
                                </Select>
                            </FormControl>
              </Grid>
              <Grid item md={1} mt={3}>
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                  <Button fullWidth sx={{
                    backgroundColor:"#688B2A",
                    color:"#fff",
                    borderRadius:"10px",
                    '&:hover': {
                      backgroundColor: "#688B3A",
                      color:"#fff",
                      borderRadius:"10px",
                    },
                    }} variant="contained" color="secondary" onClick={()=>handleSearch()}>
                    Search
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={1} mt={3}>

                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                  <Button sx={{borderRadius:"10px"}} fullWidth variant="contained" color="secondary" onClick={()=>resetFilters()}>
                    Clear
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Card>

          {/* Data Grid Section */}
          <SubCard title="Payment Orders" sx={{ marginTop: 1 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} mb={1}>
              {/* Filter Buttons */}
              <Box sx={{ display: "flex", gap: 2 }}>
                {["", "Approved", "Pending", "Rejected"].map((status) => (
                  <Button
                    key={status}
                    variant={actionFilter === status ? "contained" : "outlined"}
                    color={"secondary"}
                    onClick={() => setActionFilter(status)}
                    sx={{borderRadius:"8px"}}
                  >
                    {status === "" ? "All" : status}
                  </Button>
                ))}
              </Box>

              {/* Export to Excel Button */}
              <Button
                variant="outlined"
                color="primary"
                onClick={exportToExcel}
                startIcon={<FileDownloadIcon />}
              >
                Export to Excel
              </Button>
            </Box>
            <div style={{ height: 400, width: "100%" }}>
              {filteredData && filteredData.length > 0 ? (
                <DataGrid
                  rows={filteredData}
                  columns={columns(handleViewPO, handlePaymentOrderOpen,handleRemarksOpen)}
                  initialState={{ pagination: { paginationModel: { page: Data ? Data.page : Page-1, pageSize: 10 } } }}
                  rowsPerPageOptions={[10]}
                  pageSize={10}
                  paginationMode="server"
                  disableSelectionOnClick
                  rowHeight={80}
                  scrollbarSize={8}
                  getRowId={(row) => row._id}
                  rowCount={Data && Data.total_count}
                  onPaginationModelChange={(params) => {
                    handleChangePage(params.page)
                  }}
                  components={{
                    NoRowsOverlay: () => (
                      <Box sx={{ textAlign: "center", color: "#888", padding: 2 }}>
                        <Typography variant="body1">No matching records found.</Typography>
                      </Box>
                    ),
                  }}
                  sx={{
                    "& .MuiDataGrid-root": {
                      borderRadius: "8px", // Added border radius for smoother design
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "#F8FAFC",
                      color: "#592375",
                      fontWeight: "bold",
                      textTransform: "uppercase", // Text in headers becomes uppercase
                    },
                    "& .MuiDataGrid-cell": {
                      padding: "10px", // Slightly increased padding for readability
                    },
                    "& .MuiDataGrid-row:nth-of-type(odd)": {
                      backgroundColor: "#F6F6F6",
                    },
                    "& .MuiDataGrid-row:hover": {
                      backgroundColor: "#e0f7fa", // Light blue hover effect
                      cursor: "pointer",
                    },
                    "& .MuiDataGrid-footerContainer": {
                      backgroundColor: "#f8f9fa", // Light footer background for pagination
                    },
                  }}
                />
              ) : (
                <Typography variant="body1" align="center">
                  No data available.
                </Typography>
              )}
            </div>
          </SubCard>





       

      {/* Snackbar for Notifications */}

    </Box>
  );
};

export default PaymentOrderTable;

